module.exports = __webpack_public_path__ + "img/mental.e674bcb3.png";